var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPineapple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "pineapple1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    className: "pineapple2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pineapple3",
    d: "M64,115a52.523,52.523,0,0,1-5.916-.323c-6.432-.751-11.594-2.863-15.349-6.277a22.562,22.562,0,0,1-5.7-8.306,33.061,33.061,0,0,1-1.787-5.875A66.965,66.965,0,0,1,34,80c0-.35,0-.7.011-1.05.011-1.635.051-2.983.123-4.2a46.387,46.387,0,0,1,2.534-13.914A21.967,21.967,0,0,1,46.583,48.83a23.884,23.884,0,0,1,3.653-1.7c-3.709-5.006-7.969-8.093-12.688-9.187a2,2,0,0,1-.361-3.775,22.413,22.413,0,0,1,8.241-1.687q.475,0,.938.024a14.557,14.557,0,0,0-4.916-2.587,2,2,0,0,1,0-3.846,40.235,40.235,0,0,1,9.894-1.357q.569,0,1.121.022c-.738-1.978-2.494-5.014-6.665-8.143A2,2,0,0,1,47,13c.574,0,12.054.095,17,7.026C68.946,13.095,80.426,13,81,13a2,2,0,0,1,1.2,3.6c-4.167,3.126-5.923,6.159-6.663,8.143q.55-.022,1.118-.022a40.24,40.24,0,0,1,9.894,1.357,2,2,0,0,1,0,3.846,14.557,14.557,0,0,0-4.916,2.587q.463-.025.938-.024a22.442,22.442,0,0,1,8.24,1.687,2,2,0,0,1-.362,3.777c-4.741,1.094-8.9,4.107-12.667,9.187a25.19,25.19,0,0,1,2.765,1.217l.358.2c.177.1.353.191.525.291a21.956,21.956,0,0,1,9.9,12,46.437,46.437,0,0,1,2.534,13.928c.071,1.2.11,2.548.123,4.228.009.306.01.655.01,1a66.975,66.975,0,0,1-1.246,14.224c-1.306,6.149-3.757,10.79-7.491,14.178-3.754,3.412-8.916,5.524-15.342,6.274A52.472,52.472,0,0,1,64,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple3",
    d: "M81,15c-8,6-8,12-8,12a22.38,22.38,0,0,1,3.656-.28A38.492,38.492,0,0,1,86,28c-7,2-11,9-11,9a11.567,11.567,0,0,1,7.572-2.515A20.435,20.435,0,0,1,90,36c-7.8,1.8-12.72,8.09-15.4,12.22a24.953,24.953,0,0,1,5.03,1.91c.27.15.54.29.8.44a20.143,20.143,0,0,1,9.03,10.97,44.789,44.789,0,0,1,2.41,13.33c.08,1.35.11,2.73.12,4.14.01.33.01.66.01.99a66.05,66.05,0,0,1-1.2,13.8c-1.12,5.27-3.21,9.79-6.88,13.12-3.3,3-7.9,5.03-14.23,5.77a52.365,52.365,0,0,1-11.38,0c-6.33-.74-10.93-2.77-14.23-5.77a20.754,20.754,0,0,1-5.2-7.59A31.257,31.257,0,0,1,37.2,93.8,66.05,66.05,0,0,1,36,80c0-.33,0-.66.01-.99.01-1.41.04-2.79.12-4.14a44.789,44.789,0,0,1,2.41-13.33,20.143,20.143,0,0,1,9.03-10.97,23.666,23.666,0,0,1,5.85-2.34C50.74,44.06,45.81,37.81,38,36a20.426,20.426,0,0,1,7.428-1.515A11.569,11.569,0,0,1,53,37s-4-7-11-9a38.473,38.473,0,0,1,9.344-1.28A22.393,22.393,0,0,1,55,27s0-6-8-12c0,0,15,0,17,10,2-10,17-10,17-10m0-4c-4.832,0-12.328,1.411-17,5.984C59.328,12.411,51.832,11,47,11a4,4,0,0,0-2.4,7.2,20.187,20.187,0,0,1,4.558,4.592A43.214,43.214,0,0,0,40.9,24.154a4,4,0,0,0-1.24,7.091,22.04,22.04,0,0,0-3.285,1.1A4,4,0,0,0,37.1,39.9a19.021,19.021,0,0,1,9.931,6.435q-.751.367-1.456.773A24.187,24.187,0,0,0,34.793,60.14a48.359,48.359,0,0,0-2.658,14.525c-.072,1.213-.112,2.581-.125,4.271C32,79.291,32,79.646,32,80a68.865,68.865,0,0,0,1.291,14.647,34.971,34.971,0,0,0,1.9,6.227,24.838,24.838,0,0,0,6.2,9.005c4.07,3.7,9.607,5.982,16.456,6.783a56.346,56.346,0,0,0,12.3,0c6.862-.8,12.4-3.084,16.469-6.785,4.052-3.676,6.7-8.665,8.1-15.248A68.853,68.853,0,0,0,96,80c0-.354,0-.709-.01-1.063-.013-1.69-.053-3.059-.127-4.3a48.282,48.282,0,0,0-2.658-14.5A24.2,24.2,0,0,0,82.4,47.09c-.162-.094-.356-.2-.552-.305l-.278-.151-.106-.057q-.238-.123-.481-.242c3.029-3.484,6.3-5.6,9.914-6.437a4,4,0,0,0,.725-7.553,22.034,22.034,0,0,0-3.285-1.1,4,4,0,0,0-1.24-7.091,43.215,43.215,0,0,0-8.267-1.363A20.222,20.222,0,0,1,83.4,18.2,4,4,0,0,0,81,11Zm0,8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M64,107l5.69,5.69a52.375,52.375,0,0,1-11.38,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M91.99,79.01c.01.33.01.66.01.99a66.051,66.051,0,0,1-1.2,13.8L84,87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M74,97l9.92,9.92c-3.3,3-7.9,5.03-14.23,5.77L64,107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M64,107l-5.69,5.69c-6.33-.74-10.93-2.77-14.23-5.77L54,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M44,87l-6.8,6.8A66.051,66.051,0,0,1,36,80c0-.33,0-.66.01-.99Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pineapple4",
    x: 46.929,
    y: 79.929,
    width: 14.142,
    height: 14.142,
    transform: "translate(-45.702 63.665) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pineapple4",
    x: 66.929,
    y: 79.929,
    width: 14.142,
    height: 14.142,
    transform: "translate(-39.844 77.808) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M91.87,74.87,84,67l5.46-5.46A44.789,44.789,0,0,1,91.87,74.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pineapple4",
    x: 66.929,
    y: 59.929,
    width: 14.142,
    height: 14.142,
    transform: "translate(-25.702 71.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M44,67l-7.87,7.87a44.789,44.789,0,0,1,2.41-13.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pineapple4",
    x: 46.929,
    y: 59.929,
    width: 14.142,
    height: 14.142,
    transform: "translate(-31.56 57.808) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M91.99,79.01,84,87,74,77,84,67l7.87,7.87C91.95,76.22,91.98,77.6,91.99,79.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M84,87l6.8,6.8c-1.12,5.27-3.21,9.79-6.88,13.12L74,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M89.46,61.54,84,67,74,57l6.43-6.43A20.143,20.143,0,0,1,89.46,61.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple5",
    d: "M75,37c6-5,15-1,15-1-7.8,1.8-12.72,8.09-15.4,12.22A41.7,41.7,0,0,0,64,47a40.676,40.676,0,0,0-10.58,1.23C50.74,44.06,45.81,37.81,38,36c0,0,9-4,15,1,0,0-4-7-11-9,0,0,7-2,13-1,0,0,0-6-8-12,0,0,15,0,17,10,2-10,17-10,17-10-8,6-8,12-8,12,6-1,13,1,13,1C79,30,75,37,75,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M74.6,48.22a24.955,24.955,0,0,1,5.03,1.91c.27.15.54.29.8.44L74,57,64,47A41.7,41.7,0,0,1,74.6,48.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pineapple4",
    x: 56.929,
    y: 49.929,
    width: 14.142,
    height: 14.142,
    transform: "translate(-21.56 61.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pineapple4",
    x: 56.929,
    y: 69.929,
    width: 14.142,
    height: 14.142,
    transform: "translate(-35.702 67.808) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pineapple4",
    x: 56.929,
    y: 89.929,
    width: 14.142,
    height: 14.142,
    transform: "translate(-49.844 73.665) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M64,47,54,57l-6.43-6.43a23.666,23.666,0,0,1,5.85-2.34A40.676,40.676,0,0,1,64,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M54,57,44,67l-5.46-5.46a20.143,20.143,0,0,1,9.03-10.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M54,77,44,87l-7.99-7.99c.01-1.41.04-2.79.12-4.14L44,67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple4",
    d: "M54,97l-9.92,9.92a20.755,20.755,0,0,1-5.2-7.59A31.262,31.262,0,0,1,37.2,93.8L44,87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "pineapple6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pineapple8",
    d: "M92,80a66.05,66.05,0,0,1-1.2,13.8c-1.12,5.27-3.21,9.79-6.88,13.12-3.3,3-7.9,5.03-14.23,5.77a52.365,52.365,0,0,1-11.38,0c-6.33-.74-10.93-2.77-14.23-5.77a20.754,20.754,0,0,1-5.2-7.59,8.73,8.73,0,0,0,2.81.59c3.21,1.83,5.67,4.94,9.15,6.17a19.952,19.952,0,0,0,2.53.65c1.42.29,2.84.59,4.26.89a55.686,55.686,0,0,0,12.57,1.63,12.606,12.606,0,0,0,6.08-1.42c2.36-1.39,3.84-3.86,5.21-6.22,2.81-4.82,5.69-9.93,5.73-15.51.02-3.82-1.31-7.55-1.29-11.37.01-2.73.7-5.5.08-8.16-.67-2.84-2.72-5.09-4.42-7.46s-3.13-5.32-2.31-8.11a4.738,4.738,0,0,1,.35-.88c.27.15.54.29.8.44a20.143,20.143,0,0,1,9.03,10.97,44.789,44.789,0,0,1,2.41,13.33c.08,1.35.11,2.73.12,4.14C92,79.34,92,79.67,92,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple8",
    d: "M90,36c-7.8,1.8-12.72,8.09-15.4,12.22A41.7,41.7,0,0,0,64,47a40.674,40.674,0,0,0-10.58,1.23c-.53-.82-1.14-1.73-1.86-2.66a14.785,14.785,0,0,1,7.09-2.93c4.42-.49,8.92.24,13.33-.33.93-.12,2.04-.48,2.2-1.39.14-.81-.56-1.48-1.03-2.15a4.537,4.537,0,0,1,.21-5.32c.6-.73,1.48-1.75.82-2.43a2.044,2.044,0,0,0-.66-.37,6.579,6.579,0,0,1-3.59-5.64,16.073,16.073,0,0,1,1.36-6.83c.18-.48.37-.97.58-1.45A28.592,28.592,0,0,1,81,15c-8,6-8,12-8,12,6-1,13,1,13,1-7,2-11,9-11,9C81,32,90,36,90,36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "pineapple7",
    d: "M91.99,79.01c.01.33.01.66.01.99a66.051,66.051,0,0,1-1.2,13.8c-1.12,5.27-3.21,9.79-6.88,13.12-3.3,3-7.9,5.03-14.23,5.77a52.375,52.375,0,0,1-11.38,0c-6.33-.74-10.93-2.77-14.23-5.77a20.755,20.755,0,0,1-5.2-7.59A31.262,31.262,0,0,1,37.2,93.8,66.051,66.051,0,0,1,36,80c0-.33,0-.66.01-.99.01-1.41.04-2.79.12-4.14a44.789,44.789,0,0,1,2.41-13.33,20.143,20.143,0,0,1,9.03-10.97,23.666,23.666,0,0,1,5.85-2.34A40.676,40.676,0,0,1,64,47a41.7,41.7,0,0,1,10.6,1.22,24.955,24.955,0,0,1,5.03,1.91c.27.15.54.29.8.44a20.143,20.143,0,0,1,9.03,10.97,44.789,44.789,0,0,1,2.41,13.33C91.95,76.22,91.98,77.6,91.99,79.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pineapple7",
    d: "M53.42,48.23C50.74,44.06,45.81,37.81,38,36c0,0,9-4,15,1,0,0-4-7-11-9,0,0,7-2,13-1,0,0,0-6-8-12,0,0,15,0,17,10,2-10,17-10,17-10-8,6-8,12-8,12,6-1,13,1,13,1-7,2-11,9-11,9,6-5,15-1,15-1-7.8,1.8-12.72,8.09-15.4,12.22a.01.01,0,0,0-.01.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "pineapple7",
    points: "83.92 106.92 74 97 64 87 54 77 44 67 38.54 61.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "pineapple7",
    points: "36.01 79.01 44 87 54 97 64 107 69.69 112.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "pineapple7",
    points: "90.8 93.8 84 87 74 77 64 67 54 57 47.57 50.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "pineapple7",
    points: "64 47 74 57 84 67 91.87 74.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "pineapple7",
    points: "44.08 106.92 54 97 64 87 74 77 84 67 89.46 61.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "pineapple7",
    points: "91.99 79.01 84 87 74 97 64 107 58.31 112.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "pineapple7",
    points: "37.2 93.8 44 87 54 77 64 67 74 57 80.43 50.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "pineapple7",
    points: "64 47 54 57 44 67 36.13 74.87"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPineapple);
export default __webpack_public_path__ + "static/media/Pineapple.5cef5215c1491cb48129c7dc33eaa0e0.svg";
export { ForwardRef as ReactComponent };